import { PageHead } from '../components/ui';
import { Recruiting } from './people/Recruiting';

/**
 * Recruiting, on its own page (migration 174).
 *
 * It used to be a tab of People, which meant letting somebody run a hire meant
 * giving them every profile and review as well. As its own page it is granted
 * per person on the Employees page, and its API answers to that page alone.
 */
export function RecruitingPage() {
  return (
    <>
      <PageHead
        title="Recruiting"
        lede="The question bank we hire against, and the candidates scored on it."
      />
      <Recruiting onChanged={() => undefined} />
    </>
  );
}
